/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {FormControl} from '@mui/material';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {TimeField} from '@mui/x-date-pickers/TimeField';
import dayjs from 'dayjs';
import React from 'react';

export const CriteriaDurationPicker = ({duration, onChange}: {duration: number; onChange: (value: number) => void}) => {
  const existingMs = duration ? Number(duration) : 0;
  const [timeValue, setTimeValue] = React.useState(
    existingMs
      ? dayjs()
          .startOf('day')
          .add(Math.floor(existingMs / 60000), 'minute')
          .add(Math.floor((existingMs % 60000) / 1000), 'second')
      : dayjs().startOf('day'),
  );

  const handleTimeChange = (newValue: dayjs.Dayjs | null) => {
    if (newValue) {
      setTimeValue(newValue);
      const minutes = newValue.minute();
      const seconds = newValue.second();
      const totalMs = minutes * 60000 + seconds * 1000;
      onChange(totalMs);
    }
  };

  return (
    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimeField
          value={timeValue}
          onChange={handleTimeChange}
          label={'Duration'}
          format={'mm:ss'}
          ampm={false}
          sx={{
            height: 56,
            width: '100%',
            '& .MuiOutlinedInput-root': {
              width: '100%',
            },
          }}
        />
      </LocalizationProvider>
    </FormControl>
  );
};
